<template>
  <div>
    <h2 v-if="!selectedpdf || !selectedpdf.file">No File Found</h2>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("cms", ["selectedpdf"]),
    pdf() {
      return `${this.$imageURL}/${this.selectedpdf.file}`;
    },
  },
  mounted() {
    if (this.selectedpdf && this.selectedpdf.file) {
      window.location.href = this.pdf;
    }
  },
};
</script>
